import { TemplateOutputDTO } from './types';

export const TemplateMapper = {
  toDTO: (data: Partial<TemplateOutputDTO>): Partial<TemplateOutputDTO> => {
    return {
      ...data,
    };
  },

  toView: (data: TemplateOutputDTO): TemplateOutputDTO => {
    return data; // Return the same object for now, can be expanded if needed
  },
}; 